<script setup lang="ts">
import { computed } from 'vue';
import { User } from 'lucide-vue-next';
import { initialsOf } from '@/lib/clients';

const props = withDefaults(
  defineProps<{ name?: string | null; size?: 'sm' | 'lg' }>(),
  { name: '', size: 'sm' },
);

const initials = computed(() => initialsOf(props.name));
</script>

<template>
  <span
    class="flex shrink-0 items-center justify-center rounded-full bg-primary/10 font-semibold text-primary"
    :class="size === 'lg' ? 'size-11 text-sm' : 'size-8 text-xs'"
  >
    <template v-if="initials">{{ initials }}</template>
    <User v-else :class="size === 'lg' ? 'size-5' : 'size-4'" />
  </span>
</template>
